import Link from '../Link'
import { ContentDisplay } from '../../cdl-react-components/components'
import { WEBHOST_URL } from '../../cdl-react-components/utilities/constants'

const regionalMapDisplay = (props) => {
    const { map } = props

    return map ? (
        <Link 
            className="regional-map-display"
            href={'/map/' + map.id}
            title={map.title}>
            <ContentDisplay content={{
                title: map.title,
                subtitle: map.subtitle,
                image: WEBHOST_URL + '/' + map.image,
                publicationDate: map.publication_date,
                body: map.description
            }} />
        </Link>
    ) : null
}

export default regionalMapDisplay
